export const LIKE_REACTION = {
  code: "👍",
  name: "Thumbs Up"
}
